RivalIQ.apps.Admin.apps.Company.module('views', function (views, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    views.FinderStatus = Marionette.ItemView.extend({
        template: '#adminCompanyFinderStatusTemplate',

        templateHelpers: function () {
            const me = this;

            return {
                finished: me.isFinished()
            };
        },

        isFinished: function () {
            const me = this;

            if (!me.model.get('channel_discovery_data')) {
                return false;
            }

            const finished = me.model.get('channel_discovery_data').finished_at;
            const started = me.model.get('channel_discovery_data').started_at;

            return finished && !moment(finished).isBefore(moment(started));
        },

        poll: function () {
            const me = this;

            if (!me.isFinished()) {
                const deferred = RivalIQ.utils.async.callbackToDeferred(function (error) {
                    if (error) {
                        return RivalIQ.execute('alert:danger', 'An error occurred fetching the latest server state');
                    }
                    me.render();
                    me.pollTimeout = setTimeout(_.bind(me.poll, me), 5000);
                });

                me.model.fetch().done(deferred.resolve).fail(deferred.reject);
            }
        },

        onDestroy: function () {
            const me = this;
            clearTimeout(me.pollTimeout);
        },

        initialize: function () {
            const me = this;

            // Clone to prevent polling from updating our editing model
            // attributes
            me.model = me.model.clone();
            me.pollTimeout = setTimeout(_.bind(me.poll, me), 5000);
        }
    });

}, window.moment);
